import { render, staticRenderFns } from "./IdentificationPlate.vue?vue&type=template&id=21b2a6fa"
import script from "./IdentificationPlate.vue?vue&type=script&lang=js"
export * from "./IdentificationPlate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports